import { useContext } from 'react'
import { AnalyticContext } from '../contexts'

export const useAnalyticContext = () => useContext(AnalyticContext)
